import React from 'react';
import { useScreenInit } from './useScreenInit.js';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { CallOut } from './components/CallOut';
import { PainAgitation } from './components/PainAgitation';
import { Mechanism } from './components/Mechanism';
import { ValueStack } from './components/ValueStack';
import { PricingOffer } from './components/PricingOffer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { FinalClose } from './components/FinalClose';
import { Footer } from './components/Footer';
import { LiveViewers } from './components/LiveViewers';
import { WhatsAppButton } from './components/WhatsAppButton';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useScreenInit();
  return <div className="w-full min-h-full bg-ink-950 text-silver" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBar data-id="element-2" />
      <LiveViewers data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <CallOut data-id="element-6" />
        <PainAgitation data-id="element-7" />
        <Mechanism data-id="element-8" />
        <ValueStack data-id="element-9" />
        <PricingOffer data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Faq data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FinalClose data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <WhatsAppButton data-id="element-16" />
    </div>;
}